export interface WalletHistory {
  id: number;
  usersId: number;
  createdAt: string;
  amount: number;
  balanceWallet: number;
  transactionType: boolean;
  eventType: number;
  eventId: number;
  isDeleted: boolean
}

export const WALLET_CONSTANTS = {
  WALLET_UTILISED: 'Wallet amount used for earlier plan selections during enrolment',
  OTHER_DEDUCTIONS: 'Wallet deductions for benefit purchases made after enrolment, such as care plans (via marketplace) or newly added dependents.',
  AVAILABLE_WALLET: 'Remaining wallet balance after accounting for plan selections during enrolment and any subsequent deductions',
};
